import { writer } from "@/backend/write/BackendWriter";
import type { ServerTime, TimerData } from "@/model/timer";

import { action, defineActions } from "./actions";

export const eventActions = defineActions("event", {
  createTimer: action((target: { boardId?: string; artId?: string }) => {
    void writer.createTimer(
      { name: "", state: "stopped", duration: 0, end: 0 as ServerTime },
      target,
    );
  }),
  updateTimer: action((id: string, data: TimerData) => {
    return writer.updateTimer(id, data);
  }),
  delete: action((id: string) => {
    void writer.deleteEvent(id);
  }),
});
